var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhirlpoolStepperContactDetailsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 28.75C25.616 28.75 28.75 25.616 28.75 21.75C28.75 17.884 25.616 14.75 21.75 14.75C17.884 14.75 14.75 17.884 14.75 21.75C14.75 25.616 17.884 28.75 21.75 28.75Z",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7499 30.75L26.6992 26.6993",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.75H12.75",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 18.7499H9.75",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 23.7499H9.75",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 30.75H2.75C2.21956 30.75 1.71086 30.5392 1.33579 30.1642C0.960713 29.7891 0.75 29.2804 0.75 28.75V7.74999C0.75 7.21956 0.960713 6.71085 1.33579 6.33578C1.71086 5.96071 2.21956 5.74999 2.75 5.74999H7.74999C7.74999 4.42391 8.27677 3.15214 9.21445 2.21446C10.1521 1.27678 11.4239 0.75 12.75 0.75C14.0761 0.75 15.3478 1.27678 16.2855 2.21446C17.2232 3.15214 17.75 4.42391 17.75 5.74999H22.75C23.2804 5.74999 23.7891 5.96071 24.1642 6.33578C24.5393 6.71085 24.75 7.21956 24.75 7.74999V10.75",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.75C12.8489 4.75 12.9456 4.77932 13.0278 4.83427C13.11 4.88921 13.1741 4.96729 13.2119 5.05866C13.2498 5.15002 13.2597 5.25055 13.2404 5.34754C13.2211 5.44453 13.1735 5.53363 13.1036 5.60355C13.0336 5.67348 12.9445 5.7211 12.8475 5.74039C12.7506 5.75968 12.65 5.74978 12.5587 5.71194C12.4673 5.67409 12.3892 5.61001 12.3343 5.52778C12.2793 5.44556 12.25 5.34889 12.25 5.25C12.25 5.11739 12.3027 4.99021 12.3964 4.89645C12.4902 4.80268 12.6174 4.75 12.75 4.75",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhirlpoolStepperContactDetailsIcon);
export default __webpack_public_path__ + "static/media/whirlpool-stepper-contact-details-icon.19bb920b6b71f17b6698bd29b627abc1.svg";
export { ForwardRef as ReactComponent };